import { PostgrestError } from '@supabase/supabase-js';
import { supabaseClient } from './supabase';

interface HeatPumpQueryOptions {
  select: string;
  geofips: number;
  systems?: string[];
  orderByYear?: boolean;
}

const isMissingColumnError = (error: PostgrestError | null, columnName: string) => {
  if (!error?.message) return false;
  return error.message.includes('column') && error.message.includes(columnName);
};

const buildGeofipsVariants = (geofips: number) => {
  const raw = String(geofips).trim();
  const unpadded = raw.replace(/^0+/, '') || '0';
  const padded = raw.padStart(7, '0');
  const variants = new Set<string | number>([raw, unpadded, padded]);
  const numeric = Number(unpadded);
  if (!Number.isNaN(numeric)) {
    variants.add(numeric);
  }
  return Array.from(variants);
};

const buildHeatPumpQuery = (columnName: string, options: HeatPumpQueryOptions) => {
  const geofipsVariants = buildGeofipsVariants(options.geofips);
  let query = supabaseClient
    .from('heat_pumps')
    .select(options.select)
    .in(columnName, geofipsVariants);

  if (options.systems?.length) {
    query = query.in('system', options.systems);
  }

  if (options.orderByYear !== false) {
    query = query.order('year', { ascending: true });
  }

  return query;
};

export const fetchHeatPumps = async <T = any>(
  options: HeatPumpQueryOptions
): Promise<{ data: T[] | null; error: PostgrestError | null }> => {
  let { data, error } = await buildHeatPumpQuery('geo_fips', options);

  if (isMissingColumnError(error, 'geo_fips')) {
    ({ data, error } = await buildHeatPumpQuery('geofips', options));
  }

  if (isMissingColumnError(error, 'geofips')) {
    ({ data, error } = await buildHeatPumpQuery('geoid', options));
  }

  return { data: data as T[] | null, error };
};
